import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from 'App';

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from 'context';

// Global dayjs configuration
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import 'dayjs/locale/en';

// Configure dayjs to use DD/MM/YYYY format
dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.locale('en');

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  // Check if it's a handled error from our ApiClient
  if (event.reason && event.reason.handled) {
    // Prevent the default unhandled rejection error
    event.preventDefault();
    console.log('Handled error caught globally:', event.reason.message);
  }
});

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <App />
    </MaterialUIControllerProvider>
  </BrowserRouter>,
);
